import React, { useEffect } from 'react';
import { Col, FormContainer, ParentContainer, Row } from '../../styles';
import {
  StepHeader,
  OutlinedTextFields,
  OutlinedNotesFields,
  CommonButton,
  ModalFactory,
  CommonDropdownOutlined
} from '@Components';
import { Field, change, getFormValues, reduxForm } from 'redux-form';
import { BANK_ICON_NEW, CLOSE_POPUP_ICON } from '@Images';
import {
  SELECT_BANK_FORM,
  SELECT_BANK_SCREEN,
  screenSettings,
  totalSteps
} from '../../utils/constants';
import { connect } from 'react-redux';
import { activateLoader, disableLoader, scrollToError } from '@Redux/actions/ui-trigger';
import { NF_SCREENS } from '../../root/screenConstants';
import CancelPaymentModal from '../../utils/cancel-payment-modal';
import { alphanumeric, required } from '@Utils/validation';
import { API_URL } from '@Utils/config';
import { makeUrl } from '@Utils/library';
import { ISelectBankProps } from '../../utils/interface';
import {
  addRemitterBankDetails,
  changeNiumForexScreen,
  getNiumForexTransactionDetails,
  storeIsReferred
} from '@Redux/actions/nium-forex';
import { bindActionCreators } from 'redux';
import { NF_SELECT_BANK_EVENT } from '@Utils/constants/eventsConstants';
import { FLOW_TYPE } from '../../../../utils/constants';
import { logEvent } from '../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../utils/events/eventsConstants';

const SelectBankScreen = (props: ISelectBankProps) => {
  const {
    handleSubmit,
    getAllformVal,
    sourceCurrency,
    activateLoader,
    disableLoader,
    dispatch,
    addRemitterBankDetails,
    transactionId,
    changeNiumForexScreen,
    getNiumForexTransactionDetails,
    countryCode,
    initialize
  } = props;
  const loadPreFilledData = async () => {
    activateLoader();
    const res = await getNiumForexTransactionDetails(transactionId);
    if (res?.data?.success) {
      dispatch(storeIsReferred(res?.data?.data?.is_referral));
      const data = res?.data?.data;
      const aadharName = data?.remitter?.remitter_personal_info?.aadhar_name;
      const remitterBankId = data?.remitter_bank_id;
      const remitterBankName = data?.remitter_bank_name;
      const remitterAccountNumber = data?.remitter_account_number;
      const note = data?.notes;
      initialize({
        accHolderName: aadharName,
        bankId: remitterBankId,
        bankName: remitterBankName,
        accNumber: remitterAccountNumber,
        note: note
      });
    }
    disableLoader();
  };

  useEffect(() => {
    loadPreFilledData();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const onCancelPayment = async () => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <CancelPaymentModal
          onContinue={() => onClose(true)}
          postPan={true}
          onConfirm={() => {
            changeNiumForexScreen(NF_SCREENS.send_money);
            onClose(true);
          }}
        />
      ),
      'center-modal insta-modal',
      true
    );
  };
  const onBankSelected = async () => {
    activateLoader();
    const res = await addRemitterBankDetails(transactionId, getAllformVal);
    disableLoader();
    if (res?.data?.success) {
      const data = getAllformVal;
      const ctData = {
        pageName: NF_SCREENS.select_bank,
        ...data
      };
      logEvent(NF_SELECT_BANK_EVENT, FLOW_TYPE.TRANSACTION, ctData, LOG_TYPE.CLEVER_TAP);
      changeNiumForexScreen(NF_SCREENS.e_sign_in);
    }
    return;
  };

  const onBankIdChange = (bank: { text: string }) => {
    dispatch(change(SELECT_BANK_FORM, 'bankName', bank?.text));
  };

  const stepperData = screenSettings[NF_SCREENS.select_bank as keyof typeof screenSettings];
  return (
    <ParentContainer padding={[48, 0, 48, 0]}>
      <div className="navigationContainer">
        <img className="closeButton" src={CLOSE_POPUP_ICON} alt="close" onClick={onCancelPayment} />
      </div>
      <StepHeader
        heading={SELECT_BANK_SCREEN.heading}
        headerLogo={BANK_ICON_NEW}
        stepNumber={stepperData?.stepNumber}
        totalSteps={totalSteps}
        subHeading={SELECT_BANK_SCREEN.subHeading}
      />
      <FormContainer marginTop={45}>
        <form onSubmit={handleSubmit(onBankSelected)}>
          <Row padding={[13, 0]}>
            <Col width={450}>
              <Field
                bindToThisObject={getAllformVal?.accHolderName}
                parentClassName="form-text-field"
                type="text"
                name="accHolderName"
                component={OutlinedTextFields}
                maxWidth="450px"
                validate={[required]}
                placeholder={SELECT_BANK_SCREEN.accHolderName}
                disabled={true}
                disableUnderlineStyling={true}
                showLabel={true}
              />
            </Col>
          </Row>
          <Row padding={[13, 0]}>
            <Col width={450}>
              <Field
                bindToThisObject={getAllformVal?.bankId}
                parentClassName="form-text-field"
                type="text"
                name="bankId"
                component={CommonDropdownOutlined}
                maxWidth="450px"
                validate={[required]}
                placeholder={SELECT_BANK_SCREEN.bankName}
                url={makeUrl(`${API_URL}/niumForex/remitter-bank/dropdown`, {
                  countryCode,
                  currencyCode: sourceCurrency
                })}
                width={450}
                onDropdownChange={onBankIdChange}
              />
            </Col>
          </Row>
          <Row padding={[13, 0]}>
            <Col width={450}>
              <Field
                bindToThisObject={getAllformVal?.accNumber}
                parentClassName="form-text-field"
                type="text"
                name="accNumber"
                component={OutlinedTextFields}
                maxWidth="450px"
                validate={[required, alphanumeric]}
                disableUnderlineStyling={true}
                showLabel={true}
                placeholder={SELECT_BANK_SCREEN.accNumber}
                maxLength={50}
              />
            </Col>
          </Row>
          <Row padding={[13, 0]}>
            <Col width={450}>
              <Field
                bindToThisObject={getAllformVal?.note}
                parentClassName="form-text-field"
                type="text"
                name="note"
                component={OutlinedNotesFields}
                maxWidth="450px"
                tooltip={SELECT_BANK_SCREEN.noteToolTip}
                placeholder={SELECT_BANK_SCREEN.note}
                toolTipClassName="notes-field-tooltip"
                disableUnderlineStyling={true}
                showLabel={true}
              />
            </Col>
          </Row>
          <Row padding={[24, 0, 0, 0]}>
            <Col width={450}>
              <CommonButton text={SELECT_BANK_SCREEN.btnText} width={450} height={46} />
            </Col>
          </Row>
        </form>
      </FormContainer>
    </ParentContainer>
  );
};

const createReduxForm = reduxForm({
  form: SELECT_BANK_FORM,
  onSubmitFail: scrollToError
});

function mapStateToProps(reduxState: any) {
  const getAllformVal = getFormValues(SELECT_BANK_FORM)(reduxState);
  const {
    rootReducer: {
      userStatusReducer: { country_code: countryCode },
      niumForexReducer: {
        transactionDetails: { sourceCurrency, transactionId }
      }
    }
  } = reduxState;
  return {
    getAllformVal,
    sourceCurrency,
    transactionId,
    countryCode
  };
}

const SelectBankScreenForm = createReduxForm(SelectBankScreen);

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    {
      activateLoader,
      disableLoader,
      getNiumForexTransactionDetails,
      addRemitterBankDetails,
      changeNiumForexScreen,
      dispatch
    },
    dispatch
  )
)(SelectBankScreenForm);
